export default "__VITE_ASSET__BeDJLbBE__"